import {useSelector} from 'react-redux';

function useGetToken() {
  return useSelector((state: any) => state.authentication.user.token);
}

export default useGetToken;
